import(/* webpackMode: "eager" */ "/app/src/app/(site)/gift-cards/page.tsx");
